<template>
    <app-container class="blog-page">
        <!-- 返回按钮 -->
        <div class="blog-page__tools">
            <return-button :to="toPath">返回</return-button>
        </div>
        <!-- 骨架屏 -->
        <blog-skeleton v-if="!data"/>
        <template v-else>
            <!-- 标题 -->
            <blog-header :data="data"/>
            
            <app-image class="blog-page__thumb" :src="thumbUrl" ratio="16:9"/>
            <!-- 文章内容 -->
            <blogpost :data="content"/>
            <!-- 文章底部 -->
            <blog-footer :data="data"/>
            <!-- 评论 -->
            <blog-comment :data="data"/>
        </template>
    
    
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import ReturnButton from '@components/ReturnButton'
    import Blogpost from '@components/Blogpost'
    import BlogHeader from './components/BlogHeader'
    import BlogFooter from './components/BlogFooter'
    import BlogComment from './components/BlogComment'
    import AppImage from '@components/AppImage'
    import BlogSkeleton from '@assets/svg/inline.blog-skeleton.svg'
    
    import getArticleDetailService from '@service/getArticleDetailService'
    
    import {DEFAULT_THUMB_URL} from '@config'
    
    export default {
        name: 'Blog',
        data() {
            return {
                data: null
            }
        },
        computed: {
            id() {
                return this.$route.params.id
            },
            content() {
                const {data} = this
                const {content} = data || {}
                return content || ''
            },
            thumbUrl() {
                const {data} = this
                const {thumbUrl} = data || {}
                return thumbUrl || DEFAULT_THUMB_URL
            },
            toPath() {
                const {from} = this.$route.query
                return from || '/home'
            }
        },
        watch: {
            id: {
                handler(val) {
                    if (val) {
                        this.getArticleDetail(val)
                    }
                },
                immediate: true
            }
        },
        methods: {
            async getArticleDetail(id) {
                const data = await getArticleDetailService({id})
                this.data = data
            }
        },
        components: {
            AppImage,
            BlogComment,
            AppContainer,
            ReturnButton,
            BlogHeader,
            Blogpost,
            BlogFooter,
            BlogSkeleton
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    
    .blog-page {
        padding: $paddingMD;
        max-width: 800px;
        
        &__tools {
            margin-bottom: $paddingLG;
        }
        
        &__thumb {
            margin-bottom: $paddingLG;
        }
    }
</style>

